import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { doc, getDoc } from "firebase/firestore";
import { db } from "config/firebase";
import { RootState } from "types";

export const useUserDisplayName = () => {
  const user = useSelector((state: RootState) => state.user.user);
  const [displayName, setDisplayName] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.uid) {
      setDisplayName("");
      setLoading(false);
      return;
    }

    const fetchDisplayName = async () => {
      try {
        setLoading(true);
        const userDocRef = doc(db, "users", user.uid);
        const userDoc = await getDoc(userDocRef);
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setDisplayName(userData.displayName || user.displayName || "");
        } else {
          // Fallback to Firebase Auth displayName if Firestore doc doesn't exist
          setDisplayName(user.displayName || "");
        }
      } catch (error) {
        console.error("Error fetching user display name:", error);
        // Fallback to Firebase Auth displayName on error
        setDisplayName(user.displayName || "");
      } finally {
        setLoading(false);
      }
    };

    fetchDisplayName();
  }, [user?.uid, user?.displayName]);

  return { displayName, loading };
};